export default __webpack_public_path__ + "static/media/vehicle-withMacro.a97cab28.xlsm";